import React from 'react';
import { generateClassName } from './helpers';

import './Counter.css';

const Counter = ({ label = null, count, minDigits = 1, className = null }) => {
    // Convert count to string and pad with leading zeros if necessary
    const paddedCount = count.toString().padStart(minDigits, '0');
    // Split the padded count into individual digits
    const digits = paddedCount.split('');

    return (
        <div className={generateClassName('counter', '-container', className)}>
            <div className={generateClassName('counter', '-label', className)}>{label}</div>
            <div className={generateClassName('counter', '-count', className)}>
                {digits.map((digit, index) => (
                    <span key={index} className={generateClassName('counter', '-digit', className)}>{digit}</span>
                ))}
            </div>
        </div>
    );
};

export default Counter;